import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import xml2js, { parseString } from 'xml2js'; // import { Z_VERSION_ERROR } from 'zlib';

import _ from 'lodash'; // import {downloadFile} from 'utils'
// setCondition js => xml
// var xml2js = require('xml2js');
//     var builder = new xml2js.Builder();
//     var ouputXML = builder.buildObject(data);
// xml => js
// var parseString = require('xml2js').parseString;
//             var xml = this.responseText
//             var temp1 = {}
// parseString(xml, function (err, result) {
//                 result = searchAndDefaultValue(result)
//                 temp1 = result
//             });

function create(conditionXml) {
  return new Promise(function (resolve, reject) {
    parseString(conditionXml, function (err, result) {
      if (err) {
        reject(err);
        return;
      }

      resolve({
        xmlObj: result,
        map: getMap(result),
        getCondition: getCondition,
        getConditionItems: getConditionItems,
        getParameter: getParameter,
        setParameter: setParameter,
        getGeometry: getGeometry,
        setGeometry: setGeometry,
        getObjectCount: getObjectCount,
        save: save,
        load: load,
        clearSaved: clearSaved,
        toString: function toString() {
          var x = exportXmlObj(this.xmlObj);
          console.log('sj export ', JSON.stringify(x));
          return toXmlString(x);
        },
        downloadXml: function downloadXml() {// const t = this.toString()
          // downloadFile({ content: t, fileName:  "debug_iva.xml" })
        }
      });
    });
  });
}

function getConditionItems(xmlObj) {
  var _this = this;

  // console.log('sj kk', this.xmlObj)
  // console.log('sj map', this.map)
  var items = [];
  Object.keys(this.map).map(function (c) {
    var getItem = function getItem(cond, mainConditionId) {
      var cid = cond.$.id;
      var sid = undefined;

      if (mainConditionId) {
        sid = cid;
        cid = mainConditionId;
      }

      var enable, noEnable;

      if (cond.parameterList.enable) {
        enable = cond.parameterList.enable._ == "1";
      } else {
        noEnable = true;
      }

      return {
        name: cond.$.name,
        enable: enable,
        noEnable: noEnable,
        cid: cid,
        sid: sid,
        onChangeEnable: function onChangeEnable(enable) {
          var val = enable ? "1" : "0";

          _this.setParameter({
            cid: cid,
            sid: sid,
            pid: "enable"
          }, val); // this.setParameter(cid, "enable", val, sid)
          // console.log(`sj after changeEnable for ${cid}(${sid || ""})` + " " + val, this.map)

        }
      };
    };

    var cond = _this.map[c];
    items.push(getItem(cond));

    if (cond.subConditionList) {
      Object.keys(cond.subConditionList).map(function (subC) {
        var cid = cond.$.id;
        items.push(getItem(cond.subConditionList[subC], cid));
      });
    }
  }); // console.log('sj getConditionItems', items)

  return items; // this.setParameter("bir", "bir_camera_height_cm", 500)
  // console.log('sj after set', this.xmlObj)
} // create ref. for xmlObj


function getMap(xmlObj) {
  var condArray = undefined;

  if (xmlObj.condition_collection) {
    condArray = xmlObj.condition_collection.condition;
  } else {
    condArray = [xmlObj.condition];
  }

  var getXmlListMap = function getXmlListMap(xmlList) {
    var result = {};

    if (!xmlList) {
      return result;
    }

    var x = xmlList[0];
    Object.keys(x).map(function (type) {
      x[type].map(function (item) {
        var id = item.$.id; // add default value

        if (item._ == undefined && item.$.default) {
          item._ = item.$.default;
        } // add type


        item.$type = type;
        result[id] = item;
      });
    });
    return result;
  };

  var getGeoCondtionList = function getGeoCondtionList(geoConditionList) {
    if (!geoConditionList || geoConditionList.length == 0 || geoConditionList[0] == "") {
      return undefined;
    }

    var result = {};
    geoConditionList.map(function (gcItem) {
      gcItem.condition.map(function (c) {
        var id = c.$.id;
        result[id] = _objectSpread(_objectSpread({}, c), {}, {
          parameterList: getXmlListMap(c.parameter_list),
          geometryList: c.geometry_list && getXmlListMap(c.geometry_list)
        });
      });
    });
    return result;
  };

  var getSubConditionList = function getSubConditionList(subConditionList) {
    if (!subConditionList || subConditionList.length == 0 || subConditionList[0] == "") {
      return undefined;
    }

    var result = {};
    var condArray = subConditionList[0].condition;
    condArray.map(function (c) {
      var id = c.$.id;
      result[id] = _objectSpread(_objectSpread({}, c), {}, {
        parameterList: getXmlListMap(c.parameter_list),
        geometryList: c.geometry_list && getXmlListMap(c.geometry_list),
        geoConditionList: c.geo_condition_list && getGeoCondtionList(c.geo_condition_list)
      });
    });
    return result;
  };

  var map = {};
  condArray.map(function (c) {
    var id = c.$.id;
    map[id] = _objectSpread(_objectSpread({}, c), {}, {
      parameterList: getXmlListMap(c.parameter_list),
      geometryList: c.geometry_list && getXmlListMap(c.geometry_list),
      subConditionList: c.subcondition_list && getSubConditionList(c.subcondition_list),
      geoConditionList: c.geo_condition_list && getGeoCondtionList(c.geo_condition_list)
    });
  });
  return map;
}

function getCondition(cid, sid, gcid) {
  var cond = this.map[cid];

  if (sid) {
    cond = cond.subConditionList[sid];
  }

  if (gcid) {
    cond = cond.geoConditionList[gcid];
  }

  return cond;
} // using map to modify the xmlObj
// cid: condition id
// pid: parameter id
// sid: subcondition id
// geoCondObj: geocondition object


function setParameter(_ref, value) {
  var cid = _ref.cid,
      sid = _ref.sid,
      pid = _ref.pid,
      geoCondObj = _ref.geoCondObj;

  try {
    var cond = this.getCondition(cid, sid); // console.log('hl >>> cid: ', cid, ', pid: ', pid, ', value: ', value, ', sid: ', sid, ', geoCondObj: ', geoCondObj)

    var setValue = function setValue(p, value) {
      if (!value.$custom) {
        p._ = value;
      } else if (value.$custom == "radio") {
        var option = p.option_list[0].option;
        option.map(function (op, index) {
          if (op.$.id == value.value) {
            option[index]._ = "1";
          } else {
            option[index]._ = "0";
          }
        });
      } else if (value.$custom == "dynamic_radio") {
        /* value.value format is :
            [
                { 
                    $: 
                        { 
                            id: "CPU_INTEL_OPTIMIZED", 
                            name: "str_CPU_INTEL_OPTIMIZED", 
                            order: "1", 
                            default: "0" 
                        },
                    _: "0"
                }
            ]
         */
        if (!p.option_list) {
          p["option_list"] = [{
            option: value.value
          }];
        } else {
          p.option_list[0] = {};
          p.option_list[0].option = value.value;
        }
      } else if (value.$custom == "multi_selection") {
        if (!value || !value.option && !value.options) {} else if (value.options) {
          /* value.options format is :
              {
                  [op.$.id]: true, // or false
                  [op.$.id]: false
              }
           */
          var _option = p.option_list[0].option;
          var vo = value.options;

          _option.map(function (op, index) {
            if (vo[op.$.id] !== undefined) {
              _option[index]._ = vo[op.$.id] ? "1" : "0";
            }
          });
        } else if (value.option) {
          var _option2 = p.option_list[0].option;

          _option2.map(function (op, index) {
            if (op.$.id == _.get(value, 'option.$.id')) {
              // return value.option
              _option2[index]._ = _.get(value, 'option._') == "1" ? "1" : "0";
            }
          });
        }
      } else if (value.$custom == "multi_string") {
        //e.q. value.strings == ["set1"] or []
        var target = p;
        target.string_list = [{
          string: value.strings
        }];
      }
    };

    var gcid = undefined;
    if (geoCondObj) gcid = geoCondObj.geoCondId;
    var pType = undefined;
    var param = this.getParameter({
      cid: cid,
      sid: sid,
      pid: pid,
      gcid: gcid
    });

    if (geoCondObj && geoCondObj.paramXmlObj) {
      var gcObj = geoCondObj.paramXmlObj;
      pType = gcObj.type;

      if (gcObj.xmlObj.length == 1) {
        var gid = gcObj.xmlObj[0].gid; // get the layer-1 geometry

        var geom = this.getGeometry({
          cid: cid,
          sid: sid,
          gid: gid,
          gcid: gcid
        }); // The xmlObj format is as following: 
        // geom = {
        //     $: { arrow: "1", desc: "str_cross_line_desc", id: "cross_line_1", name: "str_cross_line" },
        //     $type: "polyline",
        //     point_list: [ { ... } ],
        //     string: [
        //         { 
        //             $: { default: "line 1", desc: "str_name_desc", id: "name", max: "100", min: "0", name: "str_name" },
        //             _: "line 1" 
        //         }
        //     ]
        // }

        if (geom) {
          var find = geom[pType].find(function (it) {
            return it.$.id == pid;
          }); // 找到圖形內的對應 parameter

          if (find) param = find;
        }
      }

      if (gcObj.xmlObj.length == 2) {
        var layer1 = gcObj.xmlObj.find(function (it) {
          return it.layer == 1;
        });
        var layer2 = gcObj.xmlObj.find(function (it) {
          return it.layer == 2;
        });

        if (layer1 && layer2) {
          var _gid = layer1.gid; // get the layer-1 geometry

          var _geom = this.getGeometry({
            cid: cid,
            sid: sid,
            gid: _gid,
            gcid: gcid
          }); // The xmlObj format is as following:
          // geom = {
          //     $: { desc: "str_cross_line_pair_desc", id: "cross_line_pair", name: "str_cross_line_pair" },
          //     $type: "polyline_pair",
          //     polyline: [
          //         {
          //             $: { arrow: "0", desc: "str_cross_line_from_desc", id: "cross_line_from", name: "str_cross_line_from" },
          //             point_list: [{ ... }],
          //             string: [
          //                 {
          //                     $: { default: "from", desc: "str_name_desc", id: "name", max: "100", min: "0", name: "str_name" },
          //                     _: "from"
          //                 }
          //             ]
          //         },
          //         ...
          //     ]
          // }


          if (_geom) {
            // get the layer-2 geometry from the layer-1 geometry
            var geom2 = _geom[layer2.type].find(function (it) {
              return it.$.id == layer2.gid;
            });

            if (geom2) {
              var _find = geom2[pType].find(function (it) {
                return it.$.id == pid;
              }); // 找到第二層圖形內的對應 parameter


              if (_find) param = _find;
            }
          }
        }
      }
    }

    setValue(param, value);
    return; // 2020/5/18: deprecated flow

    if (geoCondObj) {
      if (geoCondObj.geoCondId) {
        if (geoCondObj.paramXmlObj.xmlObj.length == 0) {
          cond = cond.geoConditionList[geoCondObj.geoCondId];
        } else {
          // parse xml object
          var geoCond = cond.geoConditionList[geoCondObj.geoCondId]; // console.log('hl >>> geo-condition: ', geoCond, ', object: ', geoCondObj)

          if (geoCondObj.paramXmlObj.type) {
            var type = geoCondObj.paramXmlObj.type; // 1 layer

            if (geoCondObj.paramXmlObj.xmlObj.length == 1) {
              var lyr_1 = geoCondObj.paramXmlObj.xmlObj.find(function (item) {
                return item.layer == 1;
              });

              if (lyr_1) {
                var g = geoCond.geometryList[lyr_1.gid];

                if (g) {
                  var p = g[type].find(function (item) {
                    return item.$.id == pid;
                  });

                  if (p) {
                    //p._ = value
                    setValue(p, value);
                  }
                }
              }
            } // 2 layers


            if (geoCondObj.paramXmlObj.xmlObj.length == 2) {
              var _lyr_ = geoCondObj.paramXmlObj.xmlObj.find(function (item) {
                return item.layer == 1;
              });

              if (_lyr_) {
                var _g = geoCond.geometryList[_lyr_.gid];

                if (_g) {
                  var lyr_2 = geoCondObj.paramXmlObj.xmlObj.find(function (item) {
                    return item.layer == 2;
                  }); //console.log('hl lyr2: ', lyr_2)

                  if (lyr_2) {
                    var g2 = _g[lyr_2.type].find(function (g) {
                      return g.$.id == lyr_2.gid;
                    });

                    if (g2) {
                      var p2 = g2[type].find(function (item) {
                        return item.$.id == pid;
                      });

                      if (p2) {
                        // p2._ = value
                        setValue(p2, value);
                      }
                    }
                  }
                }
              }
            }

            return;
          }
        }
      }
    }

    setValue(cond.parameterList[pid], value);
    return;

    if (!value.$custom) {
      // console.log('sj ??', cond.parameterList[pid], value)
      cond.parameterList[pid]._ = value;
    } else if (value.$custom == "radio") {
      // console.log('sj ??', cond.parameterList[pid], value)
      var option = cond.parameterList[pid].option_list[0].option;
      option.map(function (op, index) {
        if (op.$.id == value.value) {
          option[index]._ = "1";
        } else {
          option[index]._ = "0";
        }
      });
    } else if (value.$custom == "multi_selection") {
      if (!value || !value.option && !value.options) {} else if (value.options) {
        /* value.options format is :
            {
                [op.$.id]: true, // or false
                [op.$.id]: false
            }
         */
        var _option3 = cond.parameterList[pid].option_list[0].option;
        var vo = value.options;

        _option3.map(function (op, index) {
          if (vo[op.$.id] !== undefined) {
            _option3[index]._ = vo[op.$.id] ? "1" : "0";
          }
        });
      } else if (value.option) {
        var _option4 = cond.parameterList[pid].option_list[0].option;

        _option4.map(function (op, index) {
          if (op.$.id == _.get(value, 'option.$.id')) {
            // return value.option
            _option4[index]._ = _.get(value, 'option._') == "1" ? "1" : "0";
          }
        });
      }
    } else if (value.$custom == "multi_string") {
      //e.q. value.strings == ["set1"] or []
      var target = cond.parameterList[pid];
      target.string_list = [{
        string: value.strings
      }];
    }
  } catch (error) {
    console.error('sj setParameter fail', error, {
      cid: cid,
      pid: pid,
      value: value
    });
  }
}

function getParameter(_ref2) {
  var cid = _ref2.cid,
      sid = _ref2.sid,
      pid = _ref2.pid,
      gcid = _ref2.gcid;

  try {
    var cond = this.getCondition(cid, sid, gcid);
    return cond.parameterList[pid];
  } catch (error) {
    console.error('getParameter fail', error, {
      cid: cid,
      sid: sid,
      pid: pid,
      gcid: gcid
    });
  }
} // function setParameterList(cid, sid, parameterList) {
//     try {
//         let cond = this.map[cid]
//         if (sid) {
//             cond = cond.subConditionList[sid]
//         }
//         cond.parameterList = parameterList
//     } catch (error) {
//         console.error('setParameter fail', error, { cid, sid, parameterList })
//     }
// }


function getGeometry(_ref3) {
  var cid = _ref3.cid,
      sid = _ref3.sid,
      gid = _ref3.gid,
      gcid = _ref3.gcid;

  try {
    var cond = this.getCondition(cid, sid, gcid);
    return cond.geometryList[gid];
  } catch (error) {
    console.error('get geometry fail', error);
  }
} // when value === null means delete


function setGeometry(_ref4, value) {
  var cid = _ref4.cid,
      sid = _ref4.sid,
      gid = _ref4.gid,
      gcid = _ref4.gcid,
      oindex = _ref4.oindex;

  try {
    // this geom is belong to xmlObj
    var geom = this.getGeometry({
      cid: cid,
      sid: sid,
      gid: gid,
      gcid: gcid
    }); //console.log('sj before set geo', { count: this.getObjectCount({ cid, sid, gid, gcid }), geom, gid, value })

    if (value === null) {
      if (geom.$type == 'roi') {
        if (typeof oindex == "number") {
          var old = geom.polygon_list[0].polygon || [];
          old = old.filter(function (it, i) {
            return i != oindex;
          });

          if (old.length > 0) {
            geom.polygon_list[0].polygon = old;
          } else {
            delete geom.polygon_list;
          }
        } else {
          delete geom.polygon_list;
        }
      } else if (geom.$type == 'polyline_pair') {
        if (geom.polyline) {
          for (var i = 0; i < 2; i++) {
            delete geom.polyline[i].point_list;
          }
        }
      } else {
        delete geom.point_list;
      }
    } else {
      var $ = value.$,
          $type = value.$type;
      geom.$ = $ == undefined ? geom.$ : _objectSpread(_objectSpread({}, geom.$), $);
      geom.$type = $type || geom.$type;
      geom.color = value.color || geom.color;

      if (!geom.color) {
        delete geom.color;
      }

      if (geom.$type == 'roi') {
        if (oindex) {
          var obj = value.polygon_list[0].polygon[0];

          var _old = geom.polygon_list && geom.polygon_list[0].polygon;

          if (!_old) {
            if (!geom.polygon_list || geom.polygon_list[0] === "" || !geom.polygon_list[0].polygon) {
              // geom = { ...geom, polygon_list: [{ polygon: [] }] }
              geom.polygon_list = [{
                polygon: [obj]
              }];
            } else {
              geom.polygon_list[0].polygon = [obj];
            }
          } else if (_old.length <= oindex) {
            _old.push(obj);
          } else {
            _old[oindex] = obj;
          }
        } else {
          geom.polygon_list = value.polygon_list;
        }
      } else if (geom.$type == 'polyline_pair') {
        for (var _i = 0; _i < 2; _i++) {
          if (!geom.polyline[_i]) {
            geom.polyline[_i] = {};
          }

          geom.polyline[_i].point_list = value.polyline[_i].point_list;
        }
      } else {
        geom.point_list = value.point_list;
      }
    } // console.log('sj after set geo',
    //     {
    //         count: this.getObjectCount({ cid, sid, gid, gcid }),
    //         geom: this.getGeometry({ cid, sid, gid, gcid }),
    //         gid,
    //         value
    //     }
    // )

  } catch (error) {
    console.error('set geometry fail', error);
  }
}

function mapXml(xml, callback) {
  return xml && xml.map && xml.map(function (x) {
    var same = {};
    Object.keys(x).map(function (tag) {
      same[tag] = x[tag].map(function (item, index) {
        return callback(item, tag, index);
      });
    });
    return same;
  });
}

function mapGeometryList(geometry_list, callback) {
  if (!geometry_list) {
    return;
  }

  var g = geometry_list[0];
  var result = [{}];
  Object.keys(g).map(function (type) {
    result[0][type] = g[type].map(function (geom, index) {
      return callback(geom, type, index);
    });
  });
  return result;
} // create new xmlObj to delete `$type` in data


function exportXmlObj(xmlObj) {
  var xml = xmlObj || this.xmlObj;

  if (!xml) {
    console.warn("exportXmlObj receive undefined");
    return;
  }

  var condArray = undefined;
  var result = {};

  var deleteTypeFromGeomListForCondition = function deleteTypeFromGeomListForCondition(c) {
    if (!c.geometry_list) {
      return c;
    }

    var nGL = mapGeometryList(c.geometry_list, function (geom, type, index) {
      var r = _objectSpread({}, geom);

      delete r['$type'];
      Object.keys(r).map(function (k) {
        if (k === '$') {
          return;
        }

        if (!r[k] || !r[k].length || r[k].length == 0 || r[k][0] === "") {
          delete r[k];
        }
      });
      return r;
    });
    return _objectSpread(_objectSpread({}, c), {}, {
      geometry_list: nGL
    });
  };

  var deleteTypeFromParamListForCondition = function deleteTypeFromParamListForCondition(c) {
    if (!c.parameter_list) {
      return c;
    }

    var nPL = mapXml(c.parameter_list, function (p, type, index) {
      var r = _objectSpread({}, p);

      delete r['$type'];
      return r;
    });
    return _objectSpread(_objectSpread({}, c), {}, {
      parameter_list: nPL
    });
  };

  var deleteTypeFromGeoConditionListForCondition = function deleteTypeFromGeoConditionListForCondition(c) {
    if (!c.geo_condition_list) {
      return c;
    }

    var nGCL = mapXml(c.geo_condition_list, function (item, tag, index) {
      if (tag != 'condition') {
        return item;
      }

      return deleteType(item);
    });
    return _objectSpread(_objectSpread({}, c), {}, {
      geo_condition_list: nGCL
    });
  };

  var deleteType = function deleteType(c) {
    return deleteTypeFromGeoConditionListForCondition( // geo-condition list
    deleteTypeFromParamListForCondition( // parameter list
    deleteTypeFromGeomListForCondition(c) // geometry list
    ));
  };

  var deleteForConditionWithSubC = function deleteForConditionWithSubC(c) {
    var _c = deleteType(c);

    if (!_c.subcondition_list) {
      return _c;
    }

    var nScL = mapXml(_c.subcondition_list, function (item, tag, index) {
      if (tag != 'condition') {
        return item;
      }

      return deleteType(item);
    });
    return _objectSpread(_objectSpread({}, _c), {}, {
      subcondition_list: nScL
    });
  };

  if (xml.condition_collection) {
    condArray = xml.condition_collection.condition;
    result.condition_collection = {
      condition: condArray.map(deleteForConditionWithSubC)
    };
  } else {
    var c = deleteForConditionWithSubC(xml.condition);
    result.condition = c;
  }

  return result;
}

function getObjectCount(_ref5) {
  var cid = _ref5.cid,
      sid = _ref5.sid,
      gid = _ref5.gid,
      gcid = _ref5.gcid,
      geometry = _ref5.geometry;

  try {
    var geom; //cid,sid,gid comes first

    if (cid && gid) {
      geom = this.getGeometry({
        cid: cid,
        sid: sid,
        gid: gid,
        gcid: gcid
      });
    }

    if (geometry && !geom) {
      geom = geometry;
    }

    if (geom.$type == 'roi') {
      if (!geom.polygon_list || !geom.polygon_list[0] || !geom.polygon_list[0].polygon) {
        return 0;
      }

      return geom.polygon_list[0].polygon.length;
    } else if (geom.$type == 'polyline_pair') {
      if (!geom.polyline) {
        return 0;
      }

      for (var i in geom.polyline) {
        if (0 == getObjectCount({
          geometry: geom.polyline[i]
        })) {
          return 0;
        }
      }

      return 1;
    } else {
      if (!geom.point_list) {
        return 0;
      }

      if (!geom.point_list[0]) {
        // case for geom.point_list[0] == ""
        return 0;
      }

      return 1;
    }
  } catch (error) {
    console.error('getObjectCount fail', error, {
      cid: cid,
      sid: sid,
      gid: gid
    });
    return undefined;
  }
}

function toXmlString(xmlObj) {
  var builder = new xml2js.Builder();
  return builder.buildObject(xmlObj);
}

function save() {
  this.savedXmlObjStr = JSON.stringify(this.xmlObj);
}

function load() {
  if (!this.savedXmlObjStr) {
    console.log('no saved xmlObjStr');
    return;
  }

  this.xmlObj = JSON.parse(this.savedXmlObjStr);
  this.map = getMap(this.xmlObj);
}

function clearSaved() {
  this.savedXmlObjStr = undefined;
}

var paramType = ['string', 'boolean', 'float', 'integer', 'multi_selection', 'multi_string', 'radio'];
var geometryType = ['rectangle', 'line', 'direction', 'polygon', 'polyline'];

function getConditionJson(cid, sid, cond) {
  var layout = {
    cid: cid,
    sid: sid,
    geoItems: []
  };
  console.log('hl cond: ', cond); // XML object to geoItem's parameter object

  var getParamJson = function getParamJson(param) {
    var jsonObj = {};
    jsonObj['pid'] = param.$.id;
    jsonObj['type'] = param.$type;
    jsonObj['attr'] = param.$;
    jsonObj['value'] = param._ !== undefined ? param._ : param.$.default; // 有可能數值會有空字串('')

    jsonObj['xmlObj'] = []; // 原意應為 parentGeometry

    jsonObj['realXmlObj'] = param; // XML object of parameter

    if (param.$type == 'radio' || param.$type == "multi_selection") {
      // jsonObj['option_list'] = param.option_list
      var options = []; // check 'option_list' property

      param.option_list.map(function (item) {
        var opList = []; // check 'option' property

        if (item && item.option.length > 0) {
          item.option.map(function (op) {
            opList.push({
              attr: op.$,
              value: op._
            });
          });
        }

        options.push({
          option: opList
        });
      });
      jsonObj['options'] = options;
    }

    if (param.$type == "multi_string") {
      // jsonObj['string_list'] = param.string_list
      var strings = [];
      param.string_list.map(function (item) {
        strings.push({
          string: item.string
        });
      });
      jsonObj['strings'] = strings;
    }

    if (param.$type == 'dynamic_radio') {
      // convert `option_list` to `options`
      var _options = [];

      if (param.option_list) {
        param.option_list.map(function (item) {
          var opList = []; // check 'option' property

          if (item && item.option.length > 0) {
            item.option.map(function (op) {
              opList.push({
                attr: op.$,
                value: op._
              });
            });
          }

          _options.push({
            option: opList
          });
        });
        jsonObj['options'] = _options;
      } // convert `intersectional_option_list` to `intersection`


      var intersection = [];

      if (param.intersectional_option_list) {
        param.intersectional_option_list.map(function (item) {
          var opList = [];

          if (item && item.option.length > 0) {
            item.option.map(function (op) {
              opList.push({
                attr: op.$
              });
            });
          }

          intersection.push({
            option: opList
          });
        });
        jsonObj['intersection'] = intersection;
      }
    }

    return jsonObj;
  };

  var getXmlObj = function getXmlObj(gcid, layer, type, g) {
    if (gcid) {
      return {
        geoCondId: gcid,
        layer: layer,
        type: type,
        gid: g.$.id,
        value: _.cloneDeep(g)
      };
    } else {
      return {
        layer: layer,
        type: type,
        gid: g.$.id,
        value: _.cloneDeep(g)
      };
    }
  }; // build root geo item from parameter list


  var rootItem = {
    attr: cond.$,
    gid: "condition_root",
    type: "@root",
    parameters: []
  };

  if (cond.parameterList) {
    // console.log('hl pList: ', cond.parameterList)
    Object.keys(cond.parameterList).map(function (id) {
      var p = cond.parameterList[id]; // rootItem.parameters.push({ 
      //     pid: id, 
      //     type: p.$type,
      //     attr: p.$,
      //     value: p._ 
      // })

      rootItem.parameters.push(getParamJson(p));
    });
  }

  layout.geoItems.push(rootItem); // build geo items from geo-condition list

  if (cond.geoConditionList) {
    Object.keys(cond.geoConditionList).map(function (id) {
      var geoCond = cond.geoConditionList[id];
      var geoItem = {
        gid: geoCond.$.id,
        attr: geoCond.$,
        isGeoCondition: true,
        degree: 1,
        parameters: [],
        geoGroup: []
      };

      if (geoCond.parameterList) {
        Object.keys(geoCond.parameterList).map(function (id) {
          var p = geoCond.parameterList[id]; // geoItem.parameters.push({
          //     xmlObj: [],
          //     pid: id,
          //     type: p.$type,
          //     attr: p.$,
          //     value: p._
          // })

          geoItem.parameters.push(getParamJson(p));
        });
      } // check the geometry list


      if (geoCond.geometryList) {
        var getGeoItemParameterList = function getGeoItemParameterList(geom, showTitle, isMainTitle) {
          var paramObjList = []; // add title object

          if (showTitle) {
            var _type = isMainTitle ? "main_title" : "title";

            paramObjList.push({
              pid: geom.$.id,
              type: _type,
              attr: geom.$,
              value: null,
              xmlObj: []
            });
          }

          Object.keys(geom).map(function (prop) {
            var isParameter = paramType.find(function (it) {
              return it == prop;
            });

            if (isParameter) {
              // add title object
              // if (showTitle) {
              //     paramObjList.push({
              //         pid: geom.$.id,
              //         type: 'title',
              //         attr: geom.$,
              //         value: null,
              //         xmlObj: []
              //     })
              // }
              var parameterList = geom[prop];
              parameterList.map(function (param) {
                var jsonObj = {};
                jsonObj['pid'] = param.$.id;
                jsonObj['type'] = prop;
                jsonObj['attr'] = param.$;
                jsonObj['value'] = param._ !== undefined ? param._ : param.$.default; // 有可能數值會有空字串('')

                jsonObj['xmlObj'] = []; // 原意應為 parentGeometry

                jsonObj['realXmlObj'] = param; // XML object of parameter

                if (prop == 'radio' || prop == 'multi_selection') {
                  // jsonObj['option_list'] = param.option_list
                  var options = []; // check 'option_list' property

                  param.option_list.map(function (item) {
                    var opList = []; // check 'option' property

                    if (item && item.option.length > 0) {
                      item.option.map(function (op) {
                        opList.push({
                          attr: op.$,
                          value: op._
                        });
                      });
                    }

                    options.push({
                      option: opList
                    });
                  });
                  jsonObj['options'] = options;
                }

                if (prop == "multi_string") {
                  // jsonObj['string_list'] = param.string_list
                  var strings = [];
                  param.string_list.map(function (item) {
                    strings.push({
                      string: item.string
                    });
                  });
                  jsonObj['strings'] = strings;
                }

                if (param.$type == 'dynamic_radio') {
                  // convert `option_list` to `options`
                  var _options2 = [];

                  if (param.option_list) {
                    param.option_list.map(function (item) {
                      var opList = []; // check 'option' property

                      if (item && item.option.length > 0) {
                        item.option.map(function (op) {
                          opList.push({
                            attr: op.$,
                            value: op._
                          });
                        });
                      }

                      _options2.push({
                        option: opList
                      });
                    });
                    jsonObj['options'] = _options2;
                  } // convert `intersectional_option_list` to `intersection`


                  var intersection = [];

                  if (param.intersectional_option_list) {
                    param.intersectional_option_list.map(function (item) {
                      var opList = [];

                      if (item && item.option.length > 0) {
                        item.option.map(function (op) {
                          opList.push({
                            attr: op.$
                          });
                        });
                      }

                      intersection.push({
                        option: opList
                      });
                    });
                    jsonObj['intersection'] = intersection;
                  }
                } // paramObjList.push({
                //     xmlObj: [],
                //     type: prop,
                //     pid: param.$.id,
                //     attr: param.$,
                //     value: param._ ? param._ : param.$.default
                // })


                paramObjList.push(jsonObj);
              });
            }
          });
          return paramObjList;
        };

        var keyList = Object.keys(geoCond.geometryList);

        if (keyList.length == 1) {
          var key = keyList[0];
          var g = geoCond.geometryList[key]; //console.log('hl g: ', g)

          geoItem.type = g.$type;
          var xmlObj_lyr1 = getXmlObj(geoCond.$.id, 1, g.$type, g); // let xmlObj_lyr1 = {
          //     layer: 1,
          //     gid: g.$.id,
          //     type: g.$type,
          //     value: g,
          //     geoCondId: geoCond.$.id
          // }

          var paramList_lyr1 = getGeoItemParameterList(g, true, true);
          paramList_lyr1.map(function (param) {
            param.xmlObj.push(xmlObj_lyr1);
            geoItem.parameters.push(param);
          }); // the 2nd layer graph

          Object.keys(g).map(function (prop) {
            var isGeometry = geometryType.find(function (it) {
              return it == prop;
            });

            if (isGeometry) {
              var subGeomList = g[prop];
              subGeomList.map(function (subGeom) {
                var paramList_lyr2 = getGeoItemParameterList(subGeom, true, false);
                paramList_lyr2.map(function (param) {
                  var xmlObj_lyr2 = getXmlObj(undefined, 2, prop, subGeom); // let xmlObj_lyr2 = {
                  //     layer: 2,
                  //     gid: subGeom.$.id,
                  //     type: prop,
                  //     value: subGeom
                  // }

                  param.xmlObj.push(xmlObj_lyr1);
                  param.xmlObj.push(xmlObj_lyr2);
                  geoItem.parameters.push(param);
                });
              });
            }
          }); // merge this graph to this geo-condition

          geoItem.value = g; // Object.keys(g).map(prop => {
          //     // console.log('hl prop content: ', g[prop])
          //     // Check whether a property is a parameter
          //     let res = paramType.find(param => { 
          //         return param == prop
          //     })
          //     if (res) {
          //         let parameterList = g[prop]
          //         parameterList.map(param => {
          //             geoItem.parameters.push({
          //                 xmlObj: [{
          //                     layer: 1,
          //                     gid: g.$.id,
          //                     type: g.$type,
          //                     value: g
          //                 }],
          //                 type: prop,
          //                 pid: param.$.id,
          //                 attr: param.$,
          //                 value: param._ ? param._ : param.$.default
          //             })
          //         })
          //     }
          //     // Check whether a property is a geometry 
          //     res = geometryType.find(gType => { 
          //         return gType == prop
          //     }) 
          //     if (res) {
          //         let geometryList = g[prop]
          //         geometryList.map(geom => {
          //             console.log('hl geo type: ', prop, ', content: ', geom)
          //             Object.keys(geom).map(item => {
          //                 let res_ = paramType.find(param => { 
          //                     return param == item
          //                 })
          //                 if (res_) {
          //                     let parameterList_ = geom[item]
          //                     parameterList_.map(param_ => {
          //                         geoItem.parameters.push({
          //                             xmlObj: [{
          //                                 layer: 1,
          //                                 gid: g.$.id,
          //                                 type: g.$type,
          //                                 value: g
          //                             }, {
          //                                 layer: 2,
          //                                 gid: geom.$.id,
          //                                 type: prop,
          //                                 value: geom
          //                             }],
          //                             type: item,
          //                             pid: param_.$.id,
          //                             attr: param_.$,
          //                             value: param_._ ? param._ : param_.$.default
          //                         })
          //                     })
          //                 }
          //             })
          //         })
          //     }
          // })
        } else {
          // multiple graphs geo-condition
          geoItem.type = "@geoGroup";
          Object.keys(geoCond.geometryList).map(function (id) {
            var g = geoCond.geometryList[id]; // the geo-item for multiple graphs

            var geoGroupItem = {
              type: g.$type,
              gid: g.$.id,
              attr: g.$,
              degree: 2,
              parameters: [],
              value: g,
              parent: geoCond.$.id,
              isGeoCondition: true
            };
            var xmlObj_lyr1 = getXmlObj(geoCond.$.id, 1, g.$type, g); // let xmlObj_lyr1 = {
            //     layer: 1,
            //     gid: g.$.id,
            //     type: g.$type,
            //     value: g,
            //     geoCondId: geoCond.$.id
            // }
            // add `xmlObj` to access the correct parameter

            var paramList_lyr1 = getGeoItemParameterList(g, false);
            paramList_lyr1.map(function (it) {
              it.xmlObj.push(xmlObj_lyr1);
              geoGroupItem.parameters.push(it);
            }); // the 2nd layer graph

            Object.keys(g).map(function (prop) {
              var isGeometry = geometryType.find(function (it) {
                return it == prop;
              });

              if (isGeometry) {
                var subGeomList = g[prop];
                subGeomList.map(function (subGeom) {
                  var paramList_lyr2 = getGeoItemParameterList(subGeom, true, false);
                  paramList_lyr2.map(function (param) {
                    var xmlObj_lyr2 = getXmlObj(undefined, 2, prop, subGeom); // let xmlObj_lyr2 = {
                    //     layer: 2,
                    //     gid: subGeom.$.id,
                    //     type: prop,
                    //     value: subGeom
                    // }

                    param.xmlObj.push(xmlObj_lyr1);
                    param.xmlObj.push(xmlObj_lyr2);
                    geoGroupItem.parameters.push(param);
                  });
                });
              }
            });
            geoItem.geoGroup.push(geoGroupItem);
          });
        }
      }

      layout.geoItems.push(geoItem);
    });
  } // build geo items from geometry list


  if (cond.geometryList) {
    Object.keys(cond.geometryList).map(function (id) {
      var geo = cond.geometryList[id];
      var geoItem = {
        gid: geo.$.id,
        type: geo.$type,
        attr: geo.$,
        value: geo,
        isGeoCondition: false,
        degree: 1,
        parameters: [],
        geoGroup: []
      };
      layout.geoItems.push(geoItem);
    });
  }

  return layout;
}

function createGeoCondObj(_ref6) {
  var gcid = _ref6.gcid,
      paramType = _ref6.paramType,
      xmlObjList = _ref6.xmlObjList;
  var gcObj = {
    geoCondId: gcid,
    paramXmlObj: {
      type: paramType,
      xmlObj: []
    }
  };

  if (xmlObjList) {
    gcObj.paramXmlObj.xmlObj = _.cloneDeep(xmlObjList);
  }

  return gcObj; // return {
  //     geoCondId: gcid,
  //     paramXmlObj: paramXmlObj ? paramXmlObj : {
  //         type: paramType,
  //         xmlObj: xmlObjList ? _.cloneDeep(xmlObjList) : []
  //     }
  // }
}

export { create, getObjectCount, getConditionJson, createGeoCondObj };